export enum VIEW_MODE {
  ADD = "add",
  EDIT = "edit",
  Archived = "archived",
}
